<template>
  <b-modal ref="modal" title="Справка" ok-only ok-title="Close">
    <div class="help">
      <p>
        На данной странице показаны все конкурсы.
      </p>
      <p>
        В игре могут быть разные типы конкурсов.<br>
        Сейчас реализовано 7 типов конкурсов.
      </p>

      <hr>

      <h5>Конкурс «Высший свет» (champ)</h5>
      <p>
        Соревнование между игроками, которые прошли все уровни.
        Лиг нет.
      </p>

      <hr>

      <h5>Конкурс «Светский раут» (individual)</h5>
      <p>
        Соревнование между игроками (а не между клубами).<br>
        Игроки соревнуются между собой,
        проходя уровни из&nbsp;основной последовтельности уровней.
      </p>
      <p>
        Игроки разделены на 6 лиг.<br>
        Внутри лиги игроки разделены на группы по&nbsp;50&nbsp;человек.
        Внутри группы игроки соревнуются между собой.
      </p>
      <p>
        Игроки получают дополнительные награды за прогресс по&nbsp;медалям.
      </p>

      <hr>

      <h5>Конкурс «Прогулка в саду» (bug)</h5>
      <p>
        Соревнование между игроками (а не между клубами).<br>
        Игроки соревнуются между собой,
        проходя уровни из&nbsp;основной последовтельности уровней.
        В зачет идет сбор жуков.
        Похоже на&nbsp;конкурс «Светский раут» (individual).
      </p>
      <p>
        Игроки разделены на 6 лиг.<br>
        Внутри лиги игроки разделены на группы по&nbsp;50&nbsp;человек.<br>
        Внутри группы игроки соревнуются между собой.
      </p>

      <hr>

      <h5>Конкурс «Первенство клубов» (сlub)</h5>
      <p>
        Соревнование между клубами (а не между игроками).<br>
        Клубы разделены на лиги на основе количества игроков в&nbsp;клубе.
      </p>
      <p>
        Клубы, которые участвуют в&nbsp;конкурсе, объединяются в&nbsp;группы.
        Внутри одной группы может быть максимально 30&nbsp;клубов.
        Клубы внутри группы соревнуются между собой.
      </p>

      <hr>

      <h5>Конкурс «Чаепитие» (tea)</h5>
      <p>
        Старое название: клубный тайник (chest).
      </p>
      <p>
        Клуб пытается набрать 100 очков.<br>
        1 очко за прохождение уровня.
      </p>

      <hr>

      <h5>Конкурс «Радужный раж» (rainbow)</h5>
      <p>
        Соревнование между игроками.
        Игрок должен активировать конкурс нажав кнопку "Старт". После этого он попадает в группу из 5 человек.
      </p>
      <p>
        Конкурс идет 1 час. Очки начисляются за использование фишки "радуга". 
        Лиг нет.
      </p>
      <p>
        Награду получает только 1 место (из-за асинхронного присоединения к группе, несколько игроков могут получить 1 место).
      </p>

      <hr>

      <h5>Конкурс «Клуб путешественников» (gvnt)</h5>
      <p>
        Не используется.
      </p>

    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ContestsHelpWindow',

  methods: {
    show() {
      this.$refs['modal'].show();
    },
  },
};
</script>
